const Portatil1Services = () => {
  return (
    <div className="absolute left-[0%] top-[-50%] opacity-50 z-10">
      <img src="/assets/background/portatil-1.svg" alt="Dynatech" />
    </div>
  );
};
export default Portatil1Services;
